import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useClassesList(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getClassesList() {
    return privateFetch.get(`/v1/admin/class${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['class-lists', { data }], getClassesList, { enabled, keepPreviousData: true });
}

export default useClassesList;
